import "./noise.css";

function Noise() {
	return <div className="noiseOverlay"></div>;
}

export default Noise;
